<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Dashboard</h3>
        </div>
      </div>
      <d-row>
        <!-- Cards -->
        <d-col v-for="(card, index) in Cards" :key="index" md="6" lg="3" class="mb-4">
          <cards :id="`card-${index}`" :label="card.label" :value="card.value" />
        </d-col>
      </d-row>
      <div v-if="loading">
        <loader :is-loading="loading" />
      </div>
      <div class="row equal-cols" v-else>
        <d-col
          class="mb-4 col-lg-4 lg-s"
          v-if="this.infoDashboard.Merchants != null && this.infoDashboard.Merchants.length > 0"
        >
          <d-card class="card-small">
            <!-- Card Header -->
            <d-card-header class="border-bottom">
              <div class="float-left">
                <h6 class="m-0">Últimas negociações fechadas</h6>
              </div>
              <div class="float-right">
                <i class="fas fa-handshake"></i>
              </div>
            </d-card-header>
            <d-card-body class="p-0">
              <!-- Services List Group -->
              <d-list-group flush class="list-group-small">
                <d-list-group-item
                  v-for="(merchant, index) in this.infoDashboard.Merchants"
                  :key="index"
                  class="d-flex px-3"
                >
                  <span class="text-semibold text-fiord-blue">{{ merchant.Name }}</span>
                  <span
                    class="ml-auto text-right text-semibold padding-left-item"
                  >{{ merchant.CreatedDate | date }}</span>
                </d-list-group-item>
              </d-list-group>
            </d-card-body>
            <d-card-footer class="border-top"></d-card-footer>
          </d-card>
        </d-col>
        <d-col
          class="mb-4 col-lg-4 lg-s"
          v-if="this.infoDashboard.Items != null && this.infoDashboard.Items.length > 0"
        >
          <d-card class="card-small">
            <!-- Card Header -->
            <d-card-header class="border-bottom">
              <div class="float-left">
                <h6 class="m-0">Top 10</h6>
              </div>
              <div class="float-right">
                <i class="fas fa-dollar-sign"></i>
              </div>
            </d-card-header>
            <d-card-body class="p-0">
              <!-- Services List Group -->
              <d-list-group flush class="list-group-small">
                <d-list-group-item
                  v-for="(item, index) in this.infoDashboard.Items"
                  :key="index"
                  class="d-flex px-3"
                >
                  <span class="text-semibold text-fiord-blue">{{ item.Merchant.Name }}</span>
                  <span
                    class="ml-auto text-right text-semibold padding-left-item"
                  >{{ item.Amount | currency }}</span>
                </d-list-group-item>
              </d-list-group>
            </d-card-body>
            <d-card-footer class="border-top"></d-card-footer>
          </d-card>
        </d-col>
        <d-col
          class="mb-4 col-lg-4 lg-s"
          v-if="this.infoDashboard.QuantityProspect > 0 ||
        this.infoDashboard.QuantityMerchant > 0"
        >
          <chart-card title="Negociações" :chartData="chartDashboard"></chart-card>
        </d-col>
      </div>
    </div>
  </div>
</template>

<script>
import cards from "@/components/common/cards";
import chartCard from "@/components/common/chart-card";
import colors from "../../utils/colors";
export default {
  name: "dashboard",
  components: {
    cards,
    chartCard
  },
  data: function() {
    return {
      loading: false,
      infoDashboard: {
        QuantityProspect: 0,
        QuantityMerchant: 0,
        QuantityPartnerLink: 0,
        QuantityTotal: 0,
        TotalComission: 0,
        Merchants: [],
        Items: []
      },
      chartDashboard: {
        labels: [],
        datasets: []
      }
    };
  },
  computed: {
    Cards() {
      return [
        {
          label: "Negociações em andamento",
          value: this.$options.filters.number(
            this.infoDashboard.QuantityProspect
          )
        },
        {
          label: "Negociações concluídas",
          value: this.$options.filters.number(
            this.infoDashboard.QuantityMerchant
          )
        },
        {
          label: "Links de venda",
          value: this.$options.filters.number(
            this.infoDashboard.QuantityPartnerLink
          )
        },
        {
          label: "Comissão prevista",
          value: this.$options.filters.currency(
            this.infoDashboard.TotalComission
          )
        }
      ];
    }
  },
  mounted() {
    this.GetPartnerDashboard();
  },
  methods: {
    GetPartnerDashboard: function() {
      this.loading = true;
      this.$store
        .dispatch("GetPartnerDashboard")
        .then(response => {
          this.infoDashboard = response;
          this.infoDashboard.QuantityTotal =
            this.infoDashboard.QuantityProspect +
            this.infoDashboard.QuantityMerchant;

          this.chartDashboard = {
            labels: [],
            datasets: []
          };

          let dataset = {
            data: [],
            icons: [],
            backgroundColor: []
          };

          this.chartDashboard.labels.push("Em andamento");
          dataset.data.push(
            this.CalculateQuantityPercentage(
              this.infoDashboard.QuantityProspect
            )
          );
          dataset.icons.push('<i class="fas fa-user"></i>');
          dataset.backgroundColor.push(colors.primary.toRGBA(0.5));

          this.chartDashboard.labels.push("Concluídas");
          dataset.data.push(
            this.CalculateQuantityPercentage(
              this.infoDashboard.QuantityMerchant
            )
          );
          dataset.icons.push('<i class="fas fa-user-check"></i>');
          dataset.backgroundColor.push(colors.primary.toRGBA(1));

          this.chartDashboard.datasets.push(dataset);
        })
        .catch(error => {
          this.$makeToast(
            "Tente novamente mais tarde",
            "danger",
            "Erro ao carregar o Dashboard",
            error
          );
        })
        .finally(() => (this.loading = false));
    },
    CalculateQuantityPercentage: function(quantity) {
      let percentage = parseFloat(
        (quantity * 100) / this.infoDashboard.QuantityTotal
      );
      return percentage.toFixed(2);
    }
  }
};
</script>

<style scoped>
.padding-left-item {
  padding-left: 15px;
}
.row.equal-cols {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.row.equal-cols:before,
.row.equal-cols:after {
  display: block;
}
.row.equal-cols > [class*="col-"] {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}
.row.equal-cols > [class*="col-"] > * {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard.vue